import { AxiosBookings, userId } from "../apiConfig";
import axios from "axios";

export const paymentsApiFactory = {
  $_getAllTransactions() {
    const url = "/shippings/findShippings/byUserId";
    return AxiosBookings.get(url);
  },  
  $_getAllTransactionsByDate() {
    const url = "/shippings/findUserShippingsByDateRange/12094900/20394012";
    return AxiosBookings.get(url);
  },
  $_processPaystack(payload){
    const req = axios.create({ baseURL: "https://api.paystack.co/", headers: { Authorization: "Bearer sk_test_400a07196ba3e13f5a2f3cece57126cfbf45fe60" }});
    const url = "/transaction/initialize";
    return req.post(url, payload);
  },
  $_getUsersCard() {
    const url = `/creditcard/${userId()}`;
    return AxiosBookings.get(url);
  },
  $_setCardAsDefault(payload) {
    const url = `/creditCard/set-default/${userId()}`;
    return AxiosBookings.patch(url, payload);
  },
  $_deleteCard(id){
    const url = `/creditCard/${id}`;
    return AxiosBookings.delete(url);
  },
  $_createCard(payload){
    const url = `/creditCard`;
    return AxiosBookings.post(url, payload);
  },
  $_topWallet(payload){
    const url = `/payment/wallet/top-up`;
    return AxiosBookings.post(url, payload);
  },
  $_getUserWallet(id){
    const url = `/payment/userWallet/findUserWalletByUserId/${id}`;
    return AxiosBookings.get(url);
  },
  $_createWallet(payload){
    const url = `/payment/userWallet`;
    return AxiosBookings.post(url, payload);
  },
   $_deactivateWallet(){
    const url = `/payment/userWallet/manage/toggleUserWallet/${userId()}/true`;
    return AxiosBookings.get(url);
   },
   $_activateWallet(){
    const url = `/payment/userWallet/manage/toggleUserWallet/${userId()}/false`;
    return AxiosBookings.get(url);
   },
   $_createCardWithPaystack(payload){
    const url = `/creditCard/create-from-paystack-reference`;
    return AxiosBookings.post(url, payload);
   }
};
